import React, { useMemo } from 'react';
import cn from 'classnames';
import { useLocation } from '@reach/router';
import Container from 'components/UI/Container';
import LazyImage from 'components/UI/LazyImage';
import { useLang, isRequestedFrom } from 'utils/localisation';
import { useIsSsr } from 'utils/hooks';
import { usaRegion, ukRegion, germanRegion } from 'define/locale';
import { clients } from './constants';
import { withErrorBoundary } from 'components/ErrorBoundary';

import * as styles from './ShortCustomers.module.scss';

function ShortCustomers() {
  const currentLink = useLocation().pathname;
  const lang = useLang();
  const isSsr = useIsSsr();
  const smallerPadding = currentLink === '/contact-us';
  const logos = useMemo(() => {
    if (!isSsr) {
      if (lang === 'de' || isRequestedFrom(germanRegion)) {
        return clients.de;
      }
      if (lang === 'en' && isRequestedFrom(ukRegion)) {
        return clients.uk;
      }
      if (lang === 'en' && isRequestedFrom(usaRegion)) {
        return clients.us;
      }

      return clients.en;
    }

    return [];
  }, [lang, clients, isSsr]);

  return (
    <Container id="clients" background="transparent" padding="Vertical">
      <div className={cn(styles.layout, smallerPadding && styles.smallerPadding)}>
        <div className={styles.wrapper}>
          {logos.map(({ icon, alt }) => (
            <div key={icon} className={styles.iconWrapper}>
              <LazyImage src={icon} className={styles.icon} alt={alt ?? 'Icon'} />
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
}

ShortCustomers.displayName = 'ShortCustomers';

export default withErrorBoundary(ShortCustomers);
